let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hSLye")).then(() => parcelRequire('aYKMq'));